import React from 'react';
import { trackFbEvent } from '../utils/fbPixel';
const trackOutbound = (target: string) => trackFbEvent('OutboundClick', {
  target
});
export function Footer() {
  return <footer className="w-full px-4 sm:px-6 lg:px-8 py-10 text-gray-900 border-t" style={{
    background: 'linear-gradient(180deg, rgb(219,234,254) 0%, rgb(255,255,255) 40%)',
    borderTopColor: 'rgba(59,130,246,0.2)'
  }} data-id="element-162">
      <div className="mx-auto max-w-4xl text-center" data-id="element-163">
        {/* Logo */}
        <div className="mb-3 text-xl font-black tracking-[2.4px] text-blue-700" data-id="element-164">
          🏥 BIBLIOTECA PROFESIONAL™
        </div>

        {/* Tagline */}
        <p className="mx-auto max-w-[576px] text-xs leading-[20px] text-gray-600 m-0 mb-3" data-id="element-165">
          El sistema N°1 para estudiantes de Enfermería que quieren aprobar con
          estructura, llegar seguros a la práctica y terminar la carrera en
          Argentina.
        </p>

        <p className="text-xs italic text-gray-500 m-0 mb-6 px-4" data-id="element-166">
          "Porque aprender Enfermería con criterio clínico no debería costarte
          todas tus noches y todos tus parciales."
        </p>

        {/* Contact Info */}
        <div className="mb-6 flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-6 text-xs text-gray-600" data-id="element-167">
          <a href="mailto:soporte@bibliotecaprofesional.com" onClick={() => trackOutbound('email')} className="no-underline text-gray-600 hover:text-blue-700 transition-colors" data-id="element-168">
            📧 soporte@bibliotecaprofesional.com
          </a>
          <span className="hidden sm:block text-gray-200" data-id="element-169">|</span>
          <span className="text-gray-600" data-id="element-170">📲 @biblioteca.profesional</span>
          <span className="hidden sm:block text-gray-200" data-id="element-171">|</span>
          <a href="https://www.bibliotecaprofesional.com" target="_blank" rel="noopener noreferrer" onClick={() => trackOutbound('website')} className="no-underline text-gray-600 hover:text-blue-700 transition-colors" data-id="element-172">
            🌐 www.bibliotecaprofesional.com
          </a>
        </div>

        {/* Divider */}
        <div className="mx-auto mb-6 h-px w-24 bg-blue-700/30" data-id="element-173" />

        {/* Legal & Copyright */}
        <div className="space-y-1" data-id="element-174">
          <p className="text-[10px] text-gray-500 m-0" data-id="element-175">
            © {new Date().getFullYear()} Biblioteca Profesional™ — Todos los
            derechos reservados.
          </p>
          <p className="text-[10px] text-gray-400 m-0" data-id="element-176">
            Prohibida la reproducción total o parcial y la redistribución sin
            autorización expresa.
          </p>
        </div>
      </div>
    </footer>;
}